<template>
  <div class="container">
		<div class="hold-transition login-page">
			<div class="login-box">
        <div class="card">
          <div class="card-header">Вход в систему</div>

					<div class="card">
						<div class="card-body login-card-body">
						<form id="user-authorization">
							<div class="input-group mb-3">
                  <input type="email" class="form-control" v-model="form.email" placeholder="Почта" required
                         autocomplete="email" autofocus>
									<div class="input-group-append">
										<div class="input-group-text"><span class="fas fa-envelope"></span></div>
									</div>
              </div>

							<div class="input-group mb-3">
                  <input type="password" v-model="form.password" placeholder="Пароль" class="form-control" required>
								<div class="input-group-append">
									<div class="input-group-text">
										<span class="fas fa-lock"></span>
									</div>
								</div>
              </div>

              <div class="form-group row mb-0 " style="text-align: center">
                <div class="col-md-4 offset-md-4">
                  <button @click="sendForm" :disabled="pending" class="btn btn-primary " type="button">ВХОД</button>

                </div>
              </div>
            </form>

          </div>
         </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "login",
  data() {
    return {
      isMobile: window.innerWidth < 767,
      pending: false,
      loggedIn: 'text',
      errors: false,
      form: {
        email: null,
        password: null,
      },
    }
  },
  methods: {
    toastError(errors){
      if (errors && errors.length == 1){
        Toast.fire({
          timer: 5000,
          icon: 'error',
          title: errors
        })
      }else{
        var result = Object.keys(errors).map((key) => [errors[key]]);
        for (var i = 0; i < result.length; i++){
          Toast.fire({
            timer: 5000,
            icon: 'error',
            title: result[i][0][0]
          })
        }
      }
    },
    sendForm() {
  //   this.form.email = this.form.email.toLowerCase();
      if (this.pending === false) {
        this.pending = true;
        axios.post('/api/login', this.form)
            .then(response => {
              this.loggedIn = true;
              this.$router.go(0);
            })
            .catch((errors) => {
              this.toastError(errors.response.data.errors);
              this.pending = false;
            });
      }
    }
  },
}
</script>

<style scoped>
.login-page{
	height: 86vh!important;
	background-color:#efefef;
}
</style>